<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <div class="right_con">
          <div class="all_class one">
            <div v-for="(item, index) in bigClassList" :key="index">
              <product-item :option="1" :item="item" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumb from '../../components/bread-crumb/Index.vue'
import productItem from '../../components/product_item.vue'
import { posts } from '../../utils/posts'
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
export default {
  name: '产品中心1',
  components: {
    crumb,
    productItem
  },
  setup () {
    const route = useRoute()
    const store = useStore()
    const userInfo = store.state.userInfo || { uid: 0 }
    const setIndex = ref(0) // 中类ID
    const classTitle = ref('')
    classTitle.value = route.query.name
    const bigClassList = ref([])
    const middleClassItem = ref([])
    const SmallClassList = ref([])
    // 获取中类
    const getBigClassHandler = () => {
      posts(`classes/getBigClassWithProductCount/${userInfo.uid}`).then(
        (res) => {
          bigClassList.value = res.data
        }
      )
    }
    onMounted(() => {
      getBigClassHandler()
    })
    return {
      getBigClassHandler,
      bigClassList,
      classTitle,
      userInfo,
      setIndex,
      middleClassItem,
      SmallClassList
    }
  }
}
</script>
<style lang="scss" scoped>
.all_class {
  width: 967px;
  margin: 33px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  &.one{
    width: 100%;
    justify-content: center;
  }
}

.left_nav {
  width: 182px;
  .nav_item {
    margin: 36px 0 0 0;
    li {
      height: 24px;
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
      color: #666666;
      margin: 0 0 12px 0;
      cursor: pointer;
      &:hover {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        color: #3e3a39;
      }
      &.on {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        color: #3e3a39;
      }
    }
  }
  .nav_title {
    font-size: 34px;
    font-weight: 600;
    line-height: 46px;
    color: #3e3a39;
    .title_bg {
      padding: 0 20px;
      height: 64px;
      line-height: 64px;
      text-align: center;
      background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
      opacity: 1;
      border-radius: 5px;
      color: white;
      position: relative;
      &::before {
        position: absolute;
        content: "";
        width: 14px;
        height: 14px;
        background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
        left: 0;
        right: 0;
        bottom: -7px;
        margin: auto;
        transform: rotate(45deg);
      }
    }
  }
  &.ex_w {
    width: 208px;
  }
}
.container {
  width: 1200px;
}
.lg {
  display: flex;
  justify-content: space-between;
  margin: 36px 0 0 0;
}
</style>
